var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content example-md-doc"},[_c('div',{staticClass:"tip"},[_c('p',[_vm._v("1、空数据效果，组件本身没有提供接口，你可以自己实现，这样会更灵活一些")])])])}]

export { render, staticRenderFns }